import { FC } from 'react'

const MentorRewardIcon: FC = () => {
  return (
    <svg
      width="41"
      height="41"
      viewBox="0 0 41 41"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <desc>리워드 아이콘</desc>
      <g clipPath="url(#clip0_980_116)">
        <path
          d="M20.5 40.5C31.5457 40.5 40.5 31.5457 40.5 20.5C40.5 9.4543 31.5457 0.5 20.5 0.5C9.4543 0.5 0.5 9.4543 0.5 20.5C0.5 31.5457 9.4543 40.5 20.5 40.5Z"
          fill="white"
          stroke="#EEEEEE"
        />
        <path
          d="M20.5 10.5C22.4778 10.5 24.4112 11.0865 26.0557 12.1853C27.7002 13.2841 28.9819 14.8459 29.7388 16.6732C30.4957 18.5004 30.6937 20.5111 30.3079 22.4509C29.922 24.3907 28.9696 26.1725 27.5711 27.5711C26.1725 28.9696 24.3907 29.922 22.4509 30.3079C20.5111 30.6937 18.5004 30.4957 16.6732 29.7388C14.8459 28.9819 13.2841 27.7002 12.1853 26.0557C11.0865 24.4112 10.5 22.4778 10.5 20.5C10.5 17.8478 11.5536 15.3043 13.4289 13.4289C15.3043 11.5536 17.8478 10.5 20.5 10.5Z"
          fill="#01A0FF"
        />
        <path
          d="M21.099 24.6581C20.4257 24.672 19.7539 24.5874 19.105 24.4071C18.6068 24.2661 18.1396 24.0324 17.728 23.7181C17.3737 23.4429 17.0901 23.087 16.901 22.6801C16.7147 22.2702 16.6049 21.8296 16.577 21.3801C16.5446 20.8349 16.5446 20.2883 16.577 19.7431C16.5948 19.2846 16.6993 18.8337 16.885 18.4141C17.0741 18.0001 17.3541 17.6341 17.704 17.3431C18.1106 17.0114 18.579 16.7636 19.082 16.6141C19.7311 16.4231 20.4056 16.3331 21.082 16.3471C21.6722 16.3387 22.2608 16.4097 22.832 16.5581C23.2403 16.6547 23.6297 16.8186 23.984 17.0431C24.1026 17.1105 24.2034 17.2052 24.2782 17.3192C24.353 17.4333 24.3995 17.5635 24.414 17.6991C24.4303 17.9551 24.3599 18.2091 24.214 18.4201C24.1405 18.5316 24.0406 18.6231 23.9232 18.6868C23.8058 18.7505 23.6746 18.7842 23.541 18.7851C23.2655 18.805 22.9895 18.7519 22.741 18.6311C22.579 18.5645 22.3874 18.4978 22.166 18.4311C21.8729 18.3519 21.5696 18.3165 21.266 18.3261C20.743 18.2797 20.2195 18.4088 19.778 18.6931C19.6208 18.8266 19.495 18.9931 19.4096 19.1809C19.3242 19.3686 19.2813 19.5729 19.284 19.7791C19.2516 20.2809 19.2516 20.7843 19.284 21.2861C19.2876 21.4905 19.3349 21.6917 19.4227 21.8762C19.5105 22.0608 19.6368 22.2244 19.793 22.3561C20.2329 22.6419 20.7554 22.7731 21.278 22.7291C21.6029 22.7375 21.9266 22.6881 22.234 22.5831C22.4436 22.5071 22.6492 22.4207 22.85 22.3241C23.1235 22.1807 23.4361 22.1294 23.741 22.1781C23.8713 22.2026 23.9949 22.2542 24.1038 22.3297C24.2127 22.4052 24.3044 22.5028 24.373 22.6161C24.5022 22.8096 24.5647 23.0399 24.551 23.2721C24.5452 23.3933 24.5132 23.5119 24.4573 23.6196C24.4014 23.7273 24.3228 23.8216 24.227 23.8961C23.8701 24.146 23.4685 24.3249 23.044 24.4231C22.4096 24.5903 21.7551 24.6694 21.099 24.6581Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_980_116">
          <rect width="41" height="41" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default MentorRewardIcon
